import type { ReactNode } from 'react';

export const symbol_arrow_shape_up_stack_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M363-70v-94H213q-15 0-21-13.5t4-24.5l263-281q8.75-10 21.88-10Q494-493 503-483l263 281q10 11 4 24.5T749-164H598v94q0 12.75-8.62 21.37Q580.75-40 568-40H393q-12.75 0-21.37-8.63Q363-57.25 363-70Zm60-30h115v-94q0-12.75 8.63-21.38Q555.25-224 568-224h94L481-418 300-224h93q12.75 0 21.38 8.62Q423-206.75 423-194v94Zm58-524L253-380q-5 5-10 7.5t-12 2.5q-20.47 0-28.73-18.5Q194-407 208-422l251-268q8.75-10 21.88-10Q494-700 503-690l251 269q14 15 5.73 33-8.26 18-28.73 18-7 0-12-2.5t-10-7.5L481-624Zm0-206L254-587q-5 5-10 7.5t-12 2.5q-20.47 0-28.73-18.5Q195-614 209-629l250-267q8.75-10 21.88-10Q494-906 503-896l250 268q14 15 5.73 33-8.26 18-28.73 18-7 0-12-2.5t-10-7.5L481-830Zm0 606Z"
		/>
	</svg>
);
